import { Shield, Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToSection } from "../lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0F1115]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <img src="/images/logo.png" alt="Frontline K9 Security" className="h-14 w-auto mb-5" />
          <p className="text-sm text-gray-500 leading-relaxed max-w-xs">
            Tactical defense and high-assurance K9 surveillance for sites that cannot afford to fail.
            Licensed officers, certified dogs, integrated hardware — one command structure.
          </p>
        </div>

        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gray-500 mb-5">Navigate</p>
          <ul className="space-y-3">
            {[
              ["Capabilities", "#services", "capabilities"],
              ["Doctrine", "#manifesto", "doctrine"],
              ["K9 Units", "#gallery", "k9-units"],
              ["Request Deployment", "#quote", "deployment"],
            ].map(([label, target, id]) => (
              <li key={id}>
                <button
                  data-testid={`footer-link-${id}`}
                  onClick={() => scrollToSection(target)}
                  className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-300"
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gray-500 mb-5">Command Desk</p>
          <ul className="space-y-3 text-sm text-gray-400">
            <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-blue-500" /> 0491 301 580 — 24/7 Line</li>
            <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-blue-500" /> frontlinek9s@gmail.com</li>
            <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-blue-500" /> Unit 2, 55–61 York Rd, Jamisontown NSW</li>
            <li>
              <a
                data-testid="footer-google-link"
                href="https://share.google/pWQSrk20dt9dsv3Wj"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 hover:text-blue-400 transition-colors duration-300"
              >
                <MapPin className="w-4 h-4 text-blue-500" /> Find us on Google
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap items-center justify-between gap-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-gray-600">
            © {new Date().getFullYear()} Frontline K9 Security Pty Ltd. All perimeters reserved.
          </p>
          <Link
            data-testid="footer-admin-link"
            to="/admin/login"
            className="font-mono text-[11px] uppercase tracking-[0.2em] text-gray-600 hover:text-blue-400 transition-colors duration-300"
          >
            Command Access
          </Link>
        </div>
      </div>
    </footer>
  );
}
